module.exports = global.config = {
    base_url: "https://www.gotani.com.my/",
    mapbox_access_token: "pk.eyJ1IjoiaXQtYWRtaW4taXJhZGFyIiwiYSI6ImNsc3ZhMWU4aTBjdHIyanFrdGtmOG53bXUifQ.we9GIfvWw4bA15DVloTrrQ"
};